<template>
  <EdroneModal :index="40999" :open="openState" :show-close-icon="false">
    <template #title>
      {{ showRemindView ? trans.remind.title : trans.initial.title }}
      <font-awesome-icon
        v-if="!showRemindView"
        class="tw:ml-2 tw:text-yellow-500"
        icon="fa-solid fa-triangle-exclamation"
      />
    </template>
    <div v-if="!showRemindView" class="tw:flex tw:flex-col tw:gap-4">
      <p class="tw:body-2">
        {{ trans.initial.description.replace("{blockedMessages}", String(blockedMessages)) }}
      </p>
      <EdroneMetrics
        v-if="revenueFromOneCredit > 1"
        :title="trans.initial.estimatedLostRevenue"
        :value="revenueEstimated"
        class="tw:mb-2"
      />
      <div class="tw:flex tw:flex-col tw:gap-2">
        <EdroneButton
          class="flex-fill"
          type="solid"
          @click="
            openDrawer();
            amplitudeSendEvent('SmsBlockedModal_UpgradePackage_Clicked');
            openState = false;
          "
        >
          {{ trans.initial.buttons.upgradePackage }}
        </EdroneButton>
        <EdroneButton class="flex-fill" type="text" @click="setShowRemindView()">
          {{ trans.initial.buttons.remindLater }}
        </EdroneButton>
      </div>
    </div>
    <div v-else class="tw:flex tw:flex-col tw:gap-2 tw:pt-3">
      <EdroneButton type="outline" @click="handleRemindLater(REMIND_DURATION.ONE_HOUR)">
        {{ trans.remind.buttons.inOneHour }}
      </EdroneButton>
      <EdroneButton type="outline" @click="handleRemindLater(REMIND_DURATION.TOMORROW)">
        {{ trans.remind.buttons.tomorrow }}
      </EdroneButton>
      <div class="tw:text-center tw:pt-2">
        <span
          class="tw:cursor-pointer tw:underline tw:text-sm tw:text-gray-400 tw:hover:text-gray-500"
          @click="
            showRemindView = false;
            amplitudeSendEvent(type + 'BlockedModal_RemindLater_Back_Clicked');
          "
        >
          {{ trans.remind.back }}
        </span>
      </div>
    </div>
  </EdroneModal>
</template>

<script lang="ts" setup>
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneModal from "edrone-components/EdroneModal.vue";
import { DTOActionRequiredNotification } from "vue-app/api/dto";
import { computed, defineEmits, defineProps, ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneMetrics from "edrone-components/EdroneMetrics/EdroneMetrics.vue";
import { usePackageManager } from "vue-app/composables/usePackageManager";
import { amplitudeSendEvent } from "vue-app/utils/amplitude.ts";
import { setCookie } from "vue-app/utils/cookies";

const openState = ref(true);

const REMIND_DURATION = {
  ONE_HOUR: 1,
  TOMORROW: 24,
  ONE_WEEK: 7 * 24,
} as const;

const props = defineProps<{
  data: DTOActionRequiredNotification;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { openSMS, openWhatsapp } = usePackageManager();

const openDrawer = () => {
  if (props.data.notificationType === "NO_SMS_CREDITS") {
    openSMS();
  } else {
    openWhatsapp();
  }
};

const trans = computed(() =>
  props.data.notificationType === "NO_SMS_CREDITS"
    ? window._trans._sms.smsBlockedModal
    : window._trans._whatsApp.whatsappBlockedModal
);

const type = computed(() => (props.data.notificationType === "NO_SMS_CREDITS" ? "Sms" : "WhatsApp"));

amplitudeSendEvent(type.value + "BlockedModal_Viewed");

const showRemindView = ref(false);
const blockedMessages = computed<number>(() => Number(props.data?.details["blocked_messages"] || 0));

const revenueFromOneCredit = computed(() => Number(props.data?.details["revenue_from_one_credit"] || 0));

const revenueEstimated = computed(
  () =>
    (Number(props.data?.details["blocked_messages"] || 0) * revenueFromOneCredit.value).toFixed(2) +
    " " +
    window.EDRONE_CONTEXT.user.currency
);

const setShowRemindView = () => {
  showRemindView.value = true;
  amplitudeSendEvent(type.value + "BlockedModal_RemindLater_Clicked");
};

const handleRemindLater = (duration: number) => {
  amplitudeSendEvent(type.value + "BlockedModal_RemindLater_Confirmed", {
    duration: duration,
  });
  setCookie(
    type.value.toLowerCase() + "BlockedModalHideUntil_" + window.EDRONE_CONTEXT.trackerId,
    duration.toString(),
    duration,
    "hours"
  );
  emit("close");
};
</script>
